import { css } from 'styled-components';
export default {
    gazpacho: {
        medium: css `
      font-family: 'Gazpacho', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
    },
    matter: {
        regular: css `
      font-family: 'Matter', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'Matter', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
    },
};
